import { render, staticRenderFns } from "./RziScores.vue?vue&type=template&id=23dc88a0&"
import script from "./RziScores.vue?vue&type=script&lang=js&"
export * from "./RziScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports